import { useRef, useState } from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { RectangleStackIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import DownloadButton from "../../../../components/DownloadButton";
import useGetCarrierEandOData from "./hooks/useGetCarrierEAndOData";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "modules/CarrierAgreementMgmt/atoms";
import { useHistory } from "react-router-dom";
import { CarrierAgreementMgmtTabs } from "modules/CarrierAgreementMgmt/carrierAgreementTabs";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";

export const CarrierEAndOReports = () => {
  const [exportedData, setExportedData] = useState([]);
  const { data: al3MappedDataCount, isLoading } = useGetCarrierEandOData();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const tableRef = useRef<any>([]);
  const [searchedData, setSearchedData] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();

  const downloadCampsReport = (data) => {
    const transformed = data.map(({ tableData, ...row }) => ({
      "Carrier Name": row.carrierName,
      "E&O Submission Type": row.eAndOSubmissionType,
      "E&O Email": row.eAndOEmail,
      "E&O URL": row.eAndOUrl,
    }));
    setExportedData(transformed);
  };
  const csvReport = {
    filename: "CarrierE&OReport_" + dateTimeToday + ".csv",
    data: exportedData || [],
  };

  const columns = [
    {
      title: "Carrier Name",
      field: "carrierName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/CarrierAgreementMgmt/carriers";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  carrierName: rowData?.carrierName,
                  action: "carrierE&o",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...CarrierAgreementMgmtTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.carrierName}
            </span>
          </div>
        );
      },
    },
    { title: "E&O Submission Type", field: "eAndOSubmissionType" },
    { title: "E&O Email", field: "eAndOEmail" },
    { title: "E&O URL", field: "eAndOUrl" },
  ];

  const dataCount =
    searchText === ""
      ? al3MappedDataCount?.length ?? 0
      : searchedData?.length ?? 0;

  return (
    <div className="text-xs items-center ">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto ">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <RectangleStackIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Carrier Report
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                E&O Contact Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {dataCount}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => {
                  downloadCampsReport(
                    tableRef.current.dataManager.searchedData
                  );
                }}
                disabled={searchText !== "" && searchedData?.length === 0}
              />
            </CSVLink>
          </div>
        </div>

        <div className="box-shadow mx-4 mb-4 mt-2  grid grid-row">
          <MaterialTableTS
            data={al3MappedDataCount}
            isLoading={isLoading}
            columns={columns}
            showTitle={false}
            toolbarSearch={true}
            showToolbar={true}
            tableRef={tableRef}
            onSearchChange={(text) => {
              setSearchText(text ?? "");
              const data = tableRef.current?.dataManager?.searchedData ?? [];
              setSearchedData(data);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CarrierEAndOReports;
